import { tagName } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { expandProperties } from '@ember/object/computed';
import Component from '@ember/component';
import afterRender from 'cio/utils/after-render';

@tagName('')
export default class Base extends Component {
  @service eventBus;

  // external API
  editableEntity = null;
  eventName = null;
  filters = null;
  selectedCustomer = null;
  selectedEvent = null;
  selectedTrigger = null;
  preview = null;
  isShowingEditor = null;
  isShowingMergeData = null;
  onDirtyChange() {}
  onRollback() {}
  onSave() {}
  onFetchPreview() {}

  // internal API
  previewDidChange() {
    afterRender(() => this._fetchPreview());
  }

  @observes('isDirty')
  isDirtyDidChange() {
    this.onDirtyChange(this.get('isDirty'));
  }

  // Override the below in your subclass
  // specify an array of properties to observe - changes on those properties
  // will fire a refreshed preview
  previewObserverKeys = null;

  // provide a method to retrieve action-specific data, which should be included
  // in the preview API call. This will be passed into the fetchPreview task on
  // the action-composer component as a closure
  getPreviewData() {}

  // specify the preview API URL for this action type, e.g. 'previews/email'
  previewURL = null;

  // specify a computed property for checking dirty-ness. This will be passed
  // into the save bar as well as used in the route's ConfirmChanges mixin
  get isDirty() {
    return false;
  }

  watchedProperties = null;

  init() {
    super.init(...arguments);
    this.set('getPreviewData', this.getPreviewData.bind(this));

    let watchedProperties = [];
    let addWatchedProperty = (prop) => watchedProperties.push(prop);

    let previewObserverKeys = this.get('previewObserverKeys');
    ['selectedCustomer', 'selectedEvent', 'selectedTrigger'].concat(previewObserverKeys).forEach((key) => {
      expandProperties(key, addWatchedProperty);
    });

    this.set('watchedProperties', watchedProperties);
    // setting "observer" properties on runtime doesn't work, as it's only
    // available on classes (not on instances). If we want to observe dynamic
    // keys (whatever's passed in from the parent) we need to add observers
    // manually.
    watchedProperties.forEach((prop) => this.addObserver(prop, this, 'previewDidChange'));
  }

  willDestroyElement() {
    this.get('watchedProperties').forEach((prop) => this.removeObserver(prop, this, 'previewDidChange'));
  }

  _fetchPreview() {
    return this.onFetchPreview(this.get('previewURL'), this.getPreviewData);
  }

  @action
  fetchPreview() {
    return this._fetchPreview();
  }
}
